import { Grid } from '@mui/material';
import searchIcon from '../../../../assets/search.png';
import filter from '../../../../assets/target.png';
import budget from '../../../../assets/bag-with-dollar-sign.png';
import insights from '../../../../assets/decreasing-chart.png';
import shortList from '../../../../assets/open-folder.png';
import person from '../../../../assets/two-people.png';
import performers from '../../../../assets/trophy.png';
import content from '../../../../assets/video-camera.png';
import graph from '../../../../assets/growth.png';
import calender from '../../../../assets/number-17.png';
import rocket from '../../../../assets/rocket.png';
import speaker from '../../../../assets/speaker.png';
import tv from '../../../../assets/tv.png';
import fire from '../../../../assets/fire.png';
import transfer from '../../../../assets/transfer.png';

import HelpAndSupportComponent from './HelpAndSupportComponent';

function HelpAndSupport() {
  return (
    <Grid container width={'100%'}>
      <Grid
        item
        width={'100%'}
        height={'100%'}
        sx={{
          padding: '30px',
          border: '1px solid #9f9f9f',
          borderRadius: '5px',
          background: '#fff',
        }}
      >
        <HelpAndSupportComponent
          heading={'Discover Influencers Effortlessly'}
          icon1={searchIcon}
          icon2={filter}
          icon3={budget}
          icon4={insights}
          icon5={shortList}
          paragraphHeading1={'Smart Search'}
          paragraph1={'Find influencers using category, keywords, username, or bio search.'}
          paragraphHeading2={'Advanced Filters '}
          paragraph2={
            'Filter by location, gender, audience demographics, engagement rate, and creator type.'
          }
          paragraphHeading3={'Budget Estimation '}
          paragraph3={
            'Set campaign budgets and get predictions on influencer count, engagement, and views.'
          }
          paragraphHeading4={'Deep Insights'}
          paragraph4={
            'Analyze influencer details, including audience split, credibility score, engagement rate, and top-performing content.'
          }
          paragraphHeading5={'Shortlist & Compare'}
          paragraph5={'Create and save a list of potential influencers for easy comparison.'}
          bottomLine={'Find the perfect influencers for your brand with precision!'}
          bottomLineIcon={rocket}
          videoUrl={'https://influencer-media.s3.ap-south-1.amazonaws.com/media/loom-video.mp4'}
        ></HelpAndSupportComponent>
      </Grid>

      <Grid
        item
        width={'100%'}
        height={'100%'}
        sx={{
          padding: '30px',
          border: '1px solid #9f9f9f',
          borderRadius: '5px',
          mt: '15px',
          background: '#fff',
        }}
      >
        <HelpAndSupportComponent
          heading={'Track Your Campaigns Seamlessly'}
          icon1={insights}
          icon2={person}
          icon3={performers}
          icon4={content}
          icon5={graph}
          icon6={budget}
          icon7={searchIcon}
          icon8={calender}
          icon9={shortList}
          paragraphHeading1={' All Campaigns in One Place '}
          paragraph1={'View and manage all your brand campaigns in a single dashboard.'}
          paragraphHeading2={'Influencer Insights'}
          paragraph2={'Track influencer performance, views, engagement, likes, and comments.'}
          paragraphHeading3={'Top Performers '}
          paragraph3={
            'Identify high-performing influencers based on views, comments, and engagement rate.'
          }
          paragraphHeading4={'Content Breakdown '}
          paragraph4={'Analyze campaign content by Reels, Stories, and Posts.'}
          paragraphHeading5={'Engagement Trends'}
          paragraph5={'Monitor campaign engagement over time and track hashtag performance.'}
          paragraphHeading6={'Organic vs. Paid Comparison'}
          paragraph6={'Compare CPM, CPV, and other key metrics for organic and paid posts.'}
          paragraphHeading7={'Deep Creator Insights '}
          paragraph7={
            'Get detailed stats for each influencer, including post views, likes, and engagement.'
          }
          paragraphHeading8={'Custom Date Range'}
          paragraph8={'Filter data by specific date ranges to track campaign progress.'}
          paragraphHeading9={'Easy Reporting '}
          paragraph9={'Download detailed campaign reports for in-depth analysis.'}
          bottomLine={'Get real-time insights to optimize your campaigns effectively!'}
          bottomLineIcon={rocket}
          videoUrl={'https://influencer-prod.s3.ap-south-1.amazonaws.com/videos/loom-video+(4).mp4'}
        ></HelpAndSupportComponent>
      </Grid>

      <Grid
        item
        width={'100%'}
        height={'100%'}
        sx={{
          padding: '30px',
          border: '1px solid #9f9f9f',
          borderRadius: '5px',
          mt: '15px',
          background: '#fff',
        }}
      >
        <HelpAndSupportComponent
          heading={'Competitor Analysis Made Simple'}
          icon1={insights}
          icon2={searchIcon}
          icon3={calender}
          icon4={speaker}
          icon5={tv}
          icon6={budget}
          icon7={graph}
          icon8={fire}
          icon9={transfer}
          icon10={insights}
          paragraphHeading1={' Market Performance'}
          paragraph1={'Understand how your competitors are leveraging influencer marketing.'}
          paragraphHeading2={'Share of Voice'}
          paragraph2={'Compare your brand’s presence against competitors.'}
          paragraphHeading3={'Custom Date Selection  '}
          paragraph3={'Track competitor campaigns over specific time periods.'}
          paragraphHeading4={'Influencer Breakdown '}
          paragraph4={'See the number of mega, macro, and micro-influencers used.'}
          paragraphHeading5={'Platform Split'}
          paragraph5={'Analyze brand collaborations across Instagram & YouTube.'}
          paragraphHeading6={'Estimated Budget'}
          paragraph6={'Get insights on competitor spending based on engagement metrics.'}
          paragraphHeading7={'Campaign Performance '}
          paragraph7={'rack views, engagement, and brand activity over time.'}
          paragraphHeading8={'Top Content & Creators'}
          paragraph8={'Identify high-performing content and key influencers.'}
          paragraphHeading9={'Influencer Overlap '}
          paragraph9={'Find shared influencers between your brand and competitors.'}
          paragraphHeading10={'Performance Trends '}
          paragraph10={'Spot spikes in competitor engagement and their causes.'}
          bottomLine={'Gain an edge by staying ahead of competitor strategies!'}
          bottomLineIcon={rocket}
          videoUrl={'https://influencer-prod.s3.ap-south-1.amazonaws.com/videos/loom-video+(3).mp4'}
        ></HelpAndSupportComponent>
      </Grid>
    </Grid>
  );
}

export default HelpAndSupport;
